import {Alert, Button, Spin} from "antd";
import {CallsSection} from "./calls-section";
import {
  StyledNoUpcomingCallBox,
  StyledPageHeaderWrapper,
  StyledUpcomingCallsWrapper,
} from "./upcoming-calls.style";
import {FullPageLoader} from "../../full-page-loader";
import {LoadingSpinner} from "../../icons/icons";
import {useSessions} from "../../../features/sessions";
import {ServicesSection} from "./services-section";
import {ErrorBoundary} from "react-error-boundary";
import {StyledPageHeader} from "../../../styles/dashboard/calls/calls";
import {useGetCoachUpcomingCallsContext} from "../../../context/upcoming-calls/coach";
import {useNavigate} from "react-router-dom";

const UpcomingCallsComponent = ({
  handleNewServiceBtnClick,
}: {
  handleNewServiceBtnClick: () => void;
}) => {
  const {
    state: {
      coachUpcomingCallsData: {transactions = []},
      isFetchingCoachUpcomingCalls,
    },
  } = useGetCoachUpcomingCallsContext();
  const {
    data: sessionsData,
    isLoading: isLoadingServicesQuery,
    isFetching: isFetchingServicesQuery,
    error: servicesQueryErrorMessage,
  } = useSessions({page: 1, perPage: 1});

  const navigate = useNavigate();

  if (isLoadingServicesQuery) {
    return <FullPageLoader />;
  }

  if (servicesQueryErrorMessage) {
    return (
      <Alert
        message="Error"
        description={
          servicesQueryErrorMessage && servicesQueryErrorMessage.message
            ? servicesQueryErrorMessage.message
            : "Error fetching sessions"
        }
        type="error"
        showIcon
      />
    );
  }

  const servicesData = sessionsData?.data ?? [];

  return (
    <StyledUpcomingCallsWrapper>
      <>
        {servicesData.length > 0 && transactions.length < 1 ? (
          <ErrorBoundary
            FallbackComponent={({error, resetErrorBoundary}) => (
              <div>
                <Alert
                  message="Sorry, something went wrong."
                  showIcon
                  description={error.message}
                  type="error"
                  action={
                    <Button
                      onClick={() => {
                        resetErrorBoundary();
                      }}
                      size="small"
                      danger
                    >
                      Reset
                    </Button>
                  }
                />
              </div>
            )}
          >
            <Spin
              spinning={isFetchingCoachUpcomingCalls}
              tip="Updating..."
              indicator={LoadingSpinner}
            >
              <StyledNoUpcomingCallBox>
                <p className="info-text">
                  {isFetchingCoachUpcomingCalls
                    ? ""
                    : "You do not have any upcoming 1:1 sessions"}
                </p>
              </StyledNoUpcomingCallBox>
            </Spin>
          </ErrorBoundary>
        ) : transactions.length > 0 ? (
          <ErrorBoundary
            FallbackComponent={({error, resetErrorBoundary}) => (
              <div>
                <Alert
                  message="Sorry, something went wrong."
                  showIcon
                  description={error.message}
                  type="error"
                  action={
                    <Button
                      onClick={() => {
                        resetErrorBoundary();
                      }}
                      size="small"
                      danger
                    >
                      Reset
                    </Button>
                  }
                />
              </div>
            )}
          >
            <Spin
              spinning={isFetchingCoachUpcomingCalls}
              tip="Updating..."
              indicator={LoadingSpinner}
            >
              <CallsSection />
            </Spin>
          </ErrorBoundary>
        ) : (
          <StyledNoUpcomingCallBox>
            <p className="info-text">
              You do not have upcoming sessions or sessions at the moment. Create a new
              session to get started
            </p>
            <div>
              <Button
                onClick={() => navigate("/new-offering?selectOption=event")}
                // onClick={handleNewServiceBtnClick}
                // onClick={() => navigate("/calls/new")}
                size="small"
                block
                type="primary"
                htmlType="button"
              >
                Create a new 1:1 session
              </Button>
            </div>
          </StyledNoUpcomingCallBox>
        )}
        <ErrorBoundary
          FallbackComponent={({error, resetErrorBoundary}) => (
            <div style={{marginTop: "4rem"}}>
              <StyledPageHeaderWrapper>
                <StyledPageHeader>Sessions</StyledPageHeader>
              </StyledPageHeaderWrapper>
              <div>
                <Alert
                  message="Sorry, something went wrong."
                  showIcon
                  description={error.message}
                  type="error"
                  action={
                    <Button
                      onClick={() => {
                        resetErrorBoundary();
                      }}
                      size="small"
                      danger
                    >
                      Reset
                    </Button>
                  }
                />
              </div>
            </div>
          )}
        >
          {servicesData.length > 0 && (
            <Spin
              spinning={isFetchingServicesQuery}
              tip="Updating..."
              indicator={LoadingSpinner}
            >
              <ServicesSection showCallCategoryModal={handleNewServiceBtnClick} />
            </Spin>
          )}
        </ErrorBoundary>
      </>
    </StyledUpcomingCallsWrapper>
  );
};

export {UpcomingCallsComponent};
